import MotifLabel from '@ey/motif-react-wrapper/Label';
import React from 'react';
import styled from 'styled-components';

export default function Label(props) {
	const {id, className, children, title, position = 'in'} = props;
	return (
		<StyledLabel position={position} title={title} id={id} className={className}>
			{children}
		</StyledLabel>
	);
}

const StyledLabel = styled(MotifLabel)``;
